import { Outlet, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { Suspense, lazy, useEffect, } from 'react';
import { OidcProvider } from '../providers/OidcProvider';

import PageLoader from '../components/PageLoader';
import Layout from './layout';
import { ErrorWrapper } from '../providers/ErrorBoundary';
import AuthRoute from './AuthRoute';
import OIDCCallbackPage from '../pages/Auth/callback';
import { NAVIGATE_RECRUITMENT } from './ConstantRoutes';
import { useDispatch } from 'react-redux';
import { getAllPermissionsRoutes, userRolePermissionProvider } from '../Permissions/PermissionsOnRouteChange';
import AutoLoginRedirect from '../pages/AutoLoginRedirect';

const ProtectedRoute = lazy(() => import('./ProtectedRoute'));
const AdminLayout = lazy(() => import('../layout/AdminLayout'));
const GuestLayout = lazy(() => import('../layout/GuestLayout'));
const UserLayout = lazy(() => import('../layout/UserLayout'));
const VendorLayout = lazy(() => import('../layout/VendorLayout'));
const GuestRoutes = lazy(() => import('./GuestRoutes'));
const UserRoutes = lazy(() => import('./UserRoutes'));
const VendorPanelRoutes = lazy(() => import('./VendorPanelRoutes'));
const RedirectPage = lazy(() => import('../pages/redirect'));
// const AdminLayout = lazy(() => import('../layout/AdminLayout'));
const UserNotFound = lazy(() => import('../pages/error/UserNotFound'));




const AppRoute = () => {
    console.log("AppRoute")
    // const location = useLocation(); // Access current path
    // const dispatch = useDispatch();

    // userRolePermissionProvider(dispatch, location);
    // getAllPermissionsRoutes(dispatch);


    return (
        <Suspense fallback={<PageLoader />}>

            <Routes>
            <Route path='/auth/*' element={<OidcProvider><PermissionsProvider><AuthRoute /></PermissionsProvider></OidcProvider>}></Route>

                {/* <Route path="/" element={<Layout />}>
                <Route path='/recruitment/jobs' element={<ApproveJob />}></Route>
                <Route path='/recruitment/candidates' element={<OfferRequestAction/>}></Route>
</Route> */}

                <Route path="*" element={<Layout />}>
                    <Route path='*' element={<OidcProvider><PermissionsProvider>
                        <ErrorWrapper><AdminLayout><ProtectedRoute /></AdminLayout></ErrorWrapper>
                    </PermissionsProvider>
                    </OidcProvider>} />
                </Route>
                <Route path='/callback' element={<OidcProvider><PermissionsProvider><OIDCCallbackPage /></PermissionsProvider></OidcProvider>} />
                <Route path='/guest/*' element={<GuestLayout><PermissionsProvider><GuestRoutes /></PermissionsProvider></GuestLayout>} />
                <Route path='/user/*' element={<OidcProvider><PermissionsProvider><UserLayout><UserRoutes /></UserLayout></PermissionsProvider></OidcProvider>} />
                <Route path='/vendor-panel/*' element={<OidcProvider><PermissionsProvider><VendorLayout><VendorPanelRoutes /></VendorLayout></PermissionsProvider></OidcProvider>} />
                <Route path='/user_not_found' element={<UserNotFound />} />
                {/* /guest/action/recruitment/interview/offer-request */}
                <Route path='/redirect' element={<OidcProvider><PermissionsProvider><RedirectPage /></PermissionsProvider></OidcProvider>} />
                <Route path='/auto-login' element={<AutoLoginRedirect />} />

                {/* <Route path=
                    {(location?.pathname === '/opening/jobs' || location?.pathname === '/job/approve' || location?.pathname === '/thank-you-for-applying-job' ||
                        location?.pathname === '/offer-request/action' || location?.pathname === '/onboard-request/action' || location?.pathname === '/candidates/details'
                        || location?.pathname === '/offer-request/candidate/action' || location?.pathname === '/offer-request/upload-document' || location?.pathname === '/offer-request/candidate/action'
                    ) ? (location?.pathname) : "*"} element={<><RedirectOldRouteToNewRoute /></>} /> */}

             
            </Routes>

         </Suspense> 
    );
};

export default AppRoute;


{/* for old flow */ }
const RedirectOldRouteToNewRoute = () => {
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {

        const pathMapping: { [key: string]: string } = {
            '/opening/jobs': NAVIGATE_RECRUITMENT.OPENPAGE.JOB_OPENING_PAGE,
            '/job/approve': NAVIGATE_RECRUITMENT.OPENPAGE.JOB_APPROVE_PAGE,
            '/thank-you-for-applying-job': NAVIGATE_RECRUITMENT.OPENPAGE.JOB_THANKYOUFOR_APPLYINGJOB_PAGE,
            '/offer-request/action': NAVIGATE_RECRUITMENT.OPENPAGE.APPROVAL_OFFER_ACCEPT_REJECT_REQUEST_PAGE,
            '/onboard-request/action': NAVIGATE_RECRUITMENT.OPENPAGE.INTERVIEW_ONBOARD_REQUEST_PAGE,

            '/candidates/details': NAVIGATE_RECRUITMENT.CANDIDATE.CANDIDATE_DETAILS_PAGE,

            // '/offer-request/candidate/action': "WIP", 
            '/offer-request/upload-document': NAVIGATE_RECRUITMENT.OPENPAGE.INTERVIEW_UPLOADDOCUMENT_REQUEST_PAGE,
            '/offer-request/candidate/action': NAVIGATE_RECRUITMENT.OPENPAGE.CANDIDATE_OFFER_ACCEPT_REJECT_REQUEST_PAGE,
        };

        const matchedPath = Object?.keys(pathMapping)?.find(path => location?.pathname === path);

        if (matchedPath) {   // If a match is found, replace and navigate
            const newPath = location.pathname.replace(matchedPath, pathMapping[matchedPath]);
            const newUrl = `${newPath}${location.search}`;
            navigate(newUrl, { replace: true });
        }

    }, [location]);

    return null;
}

const PermissionsProvider = ({ children }:any) => {
    const dispatch = useDispatch();
    const location = useLocation();
console.log("PermissionsProvider")
    // useEffect(() => {
        userRolePermissionProvider(dispatch, location);
        getAllPermissionsRoutes(dispatch);
    // }, [dispatch, location]);

    return children;
};
